import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Transmission, TransmissionFromBackend } from './entities/transmission';

@Injectable()
export class HttpService {
    constructor(
        private http: HttpClient,
    ) {
    }

    public GetTransmissionFromSlug(slug: string): Promise<Transmission> {
        return this.http.get(environment.backendUrl + 'transmission/slug/' + slug).pipe(
            map(res => TransmissionFromBackend(res))
        ).toPromise();
    }
}
